import * as _ from 'underscore';

import { Module } from '../Module';

interface ITypeaheadFormatAttributes extends ng.IAttributes {
  tbTypeaheadFormat: string;
  tbMatchPrefixesOnly: string;
}

Module.instance().directive('tbTypeaheadFormat', ['$interpolate',
  ($interpolate: ng.IInterpolateService) => {

    function escapeRegexp(queryToEscape: string): string {
      return _.escape(queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function formatMatch(input: string, target: string, prefixesOnly: boolean) {
      // Construct regex for highlighting matching fragments. The input string is tokenized
      // and each token is a potential match.
      // e.g. the input string 'Ab Cd' is turned into the regex '(Ab|Cd)'.
      const regex = (prefixesOnly ? '\\b' : '') + '(' + _.compact(escapeRegexp(input).split(' ')).join('|') + ')';

      return _.escape(target).replace(new RegExp(regex, 'gi'), '<strong>$&</strong>');
    }

    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ITypeaheadFormatAttributes) => {
        const matchText = scope.$eval(attrs.tbTypeaheadFormat);
        const matchPrefixesOnly = scope.$eval(attrs.tbMatchPrefixesOnly);
        const itemText = $interpolate(element.text())(scope);
        if (matchText) {
          element.empty().append(formatMatch(matchText, itemText, matchPrefixesOnly));
        }
      }
    };
  }
]);
